var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElixir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8505_4536)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9066 0.150879C27.5475 1.69601 23.3395 6.20582 19.2827 13.6803C13.1974 24.8921 5.33795 40.8242 16.1604 53.4385C21.1673 59.2743 29.4341 62.7185 40.2832 57.2636C48.9987 52.8814 51.4226 40.3056 48.2936 34.3961C41.8391 22.2058 35.2907 19.1991 33.5372 11.6392C32.3682 6.59931 31.8246 2.76986 31.9066 0.150879Z",
    fill: "url(#paint0_linear_8505_4536)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9061 0C27.5249 1.56106 23.3169 6.07087 19.2822 13.5294C13.2301 24.7173 5.33748 40.6733 16.16 53.2876C21.1668 59.1234 29.3273 61.0092 33.8554 57.5481C36.8073 55.2917 38.815 53.141 39.9717 48.6093C41.2596 43.5634 40.2714 36.7701 39.5943 33.6493C38.7375 29.7003 38.457 25.366 38.753 20.6464C38.6487 20.5194 38.5708 20.4243 38.5192 20.3612C36.1618 17.4762 34.3427 14.9633 33.5367 11.4883C32.3677 6.44843 31.8242 2.61898 31.9061 0Z",
    fill: "url(#paint1_linear_8505_4536)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.279 1.96289C24.1982 5.18804 21.1641 10.5977 19.1766 18.1919C16.1953 29.5833 15.8722 40.0879 16.9237 46.1979C18.962 58.0426 29.5292 62.5387 40.3681 57.0254C47.0386 53.6325 49.8169 46.3496 49.6697 38.4444C49.5173 30.2591 33.6997 20.9824 30.8984 14.1512C29.0309 9.59709 28.1578 5.53432 28.279 1.96289Z",
    fill: "url(#paint2_linear_8505_4536)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6243 23.3196C43.5184 29.5962 44.5852 33.9654 41.8248 36.4273C37.6841 40.1202 27.5584 42.5296 21.2592 38.0625C17.0597 35.0844 15.4708 28.6957 16.4924 18.8965C14.7588 22.5168 13.2931 26.1843 12.0952 29.8988C10.8973 33.6134 10.5475 37.5006 11.0457 41.5605C12.547 44.5977 16.1971 46.6261 21.9961 47.6459C30.6946 49.1755 38.9275 48.4197 44.4518 45.6349C48.1347 43.7784 49.8766 41.9302 49.6777 40.0905C49.8106 37.3738 48.9728 34.7876 47.1644 32.332C45.356 29.8764 42.5093 26.8723 38.6243 23.3196Z",
    fill: "url(#paint3_linear_8505_4536)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4989 17.0522C19.458 21.5852 20.6236 25.8943 22.9956 29.9795C26.5535 36.1074 30.7067 42.1625 36.9215 47.1817C41.0647 50.5278 44.3753 51.6088 46.8533 50.4248C44.818 54.0674 42.6539 55.8523 40.3609 55.7795C36.9215 55.6703 32.7277 54.1672 26.0082 46.0922C21.5285 40.709 18.4639 35.6167 16.8145 30.8156C17.076 28.9109 17.3534 27.0137 17.6465 25.1242C17.9397 23.2346 18.5572 20.544 19.4989 17.0522Z",
    fill: "url(#paint4_linear_8505_4536)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0103 23.273C30.3905 26.9657 31.8274 32.8726 30.0103 36.8055C28.1932 40.7383 19.8003 47.8431 22.1171 54.1018C24.4339 60.3605 30.0799 58.9554 33.6215 56.0711C37.1631 53.1867 39.0588 48.4967 39.479 45.1984C39.8992 41.9001 38.4736 35.5537 38.01 30.0334C37.7009 26.3533 37.9106 23.1979 38.6392 20.5674L37.5539 19.2018L31.1663 17.3105C30.1422 18.8238 29.7569 20.8113 30.0103 23.273Z",
    fill: "url(#paint5_linear_8505_4536)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2906 4.98242C30.2232 5.856 28.2645 7.58698 26.4143 10.1754C23.6391 14.0579 22.2257 16.3853 23.2719 24.0815C23.9694 29.2123 24.4687 33.9325 24.7697 38.2422L33.7163 12.2481C33.3873 10.9236 33.1138 9.72743 32.8956 8.65953C32.6774 7.59164 32.4757 6.36593 32.2906 4.98242Z",
    fill: "url(#paint6_linear_8505_4536)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6994 12.1968C31.4282 13.5224 29.6684 16.2383 28.4199 20.3444C27.1713 24.4505 26.0291 30.1907 24.9932 37.5651C26.3749 32.8747 27.2914 29.4775 27.7428 27.3734C28.4199 24.2173 28.6511 19.7542 30.4489 16.7242C31.6475 14.7042 32.731 13.195 33.6994 12.1968Z",
    fill: "#330A4C",
    fillOpacity: 0.316321
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1836 56.1919C26.9211 56.7259 28.8754 57.2006 29.0467 57.616C29.3035 58.2392 28.5735 58.8093 26.4989 58.4262C25.1158 58.1708 24.0107 57.426 23.1836 56.1919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0612 4.98242C23.0054 7.43828 21.2241 10.0419 19.7172 12.7932C18.2103 15.5446 17.1335 17.5972 16.487 18.951C16.2866 19.9608 16.1888 21.4507 16.1935 23.4208C16.1983 25.391 16.3687 27.5815 16.7047 29.9925C16.9989 25.2713 17.8996 20.6886 19.4067 16.2444C20.9138 11.8001 22.7986 8.04616 25.0612 4.98242Z",
    fill: "#EDEDED",
    fillOpacity: 0.603261
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8505_4536",
    x1: 31.0669,
    y1: 4.57313,
    x2: 28.9855,
    y2: 59.9546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D8DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.385275
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8505_4536",
    x1: 32.0072,
    y1: 4.55928,
    x2: 10.2547,
    y2: 52.2347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D67AF",
    stopOpacity: 0.671932
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F8DAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8505_4536",
    x1: 34.4361,
    y1: 20.0061,
    x2: 34.4361,
    y2: 58.3448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26053D",
    stopOpacity: 0.761634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B4B4",
    stopOpacity: 0.277683
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8505_4536",
    x1: 14.7645,
    y1: 22.5989,
    x2: 24.5247,
    y2: 48.4531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91739F",
    stopOpacity: 0.45955
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32054F",
    stopOpacity: 0.539912
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8505_4536",
    x1: 40.8524,
    y1: 54.3913,
    x2: 14.0128,
    y2: 32.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#463D49",
    stopOpacity: 0.331182
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#340A50",
    stopOpacity: 0.821388
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8505_4536",
    x1: 35.3359,
    y1: 20.3676,
    x2: 16.4062,
    y2: 49.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#715383",
    stopOpacity: 0.145239
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4",
    stopOpacity: 0.233639
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8505_4536",
    x1: 37.1464,
    y1: 29.1507,
    x2: 23.7408,
    y2: 28.3323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A1A8",
    stopOpacity: 0.356091
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#370C50",
    stopOpacity: 0.581975
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8505_4536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElixir);
export default __webpack_public_path__ + "static/media/elixir.56ce05323d9eb1ecdeffca777fc63e78.svg";
export { ForwardRef as ReactComponent };